import { create } from 'zustand'
import type { IPropertyDetail } from '../../../interfaces'

interface ModalReassignAdviserState {
  modalReassignAdviser: {
    isOpen: boolean
    properties: IPropertyDetail[]
    onSuccess?: () => void
  }
  setModalReassignAdviser: (modalReassignAdviserIsOpen: {
    isOpen: boolean
    properties: IPropertyDetail[]
    onSuccess?: () => void
  }) => void
  reset: () => void
}

export const useModalReassignAdviserStore = create<ModalReassignAdviserState>()(
  (set) => ({
    modalReassignAdviser: {
      isOpen: false,
      properties: []
    },
    setModalReassignAdviser: (modalReassignAdviserIsOpen) =>
      set({ modalReassignAdviser: modalReassignAdviserIsOpen }),
    reset: () =>
      set({
        modalReassignAdviser: {
          isOpen: false,
          properties: []
        }
      })
  })
)
